import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconNames } from '@app/shared/enums/icon-names';
import { IceInputFieldComponent } from '@app/shared/components/molecules/ice-input-field/ice-input-field.component';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { FormValidationService } from '@app/shared/services/form-validation.service';

@Component({
  selector: 'app-whitelist-entries-input',
  templateUrl: './whitelist-entries-input.component.html',
  styleUrl: './whitelist-entries-input.component.scss',
  imports: [FormsModule, ReactiveFormsModule, IceAlertComponent, IceInputFieldComponent],
})
export class WhitelistEntriesInputComponent {
  @Input() form: FormGroup;
  getMsisdnErrorText = FormValidationService.getMsisdnErrorText;

  get whiteListEntry1Controls() {
    return this.form.controls.whitelistEntry1;
  }
  get whiteListEntry2Controls() {
    return this.form.controls.whitelistEntry2;
  }
  get whiteListEntry3Controls() {
    return this.form.controls.whitelistEntry3;
  }

  IconNames = IconNames;

  constructor() {}
}
